import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './inline-warning.scss';

export class InlineWarningList extends Component {
  render() {
    const { show, warningMain, warningList } = this.props;
    var count = -1;
    var listDisplay = (
      warningList.map( function(warning) {
        count++;
        return (
          <li key={count} role="presentation">
            { warning }
          </li>
        );
      })
    );
    return show ? (
      <ul role="alert" className="alert alert-warning warning-list" aria-live="assertive">
        { warningMain }
        { listDisplay }
      </ul>
    ) : null;
  }
}

InlineWarningList.propTypes = {
  show: PropTypes.bool,
  warningMain: PropTypes.string,
  warningList: PropTypes.array
};

export default InlineWarningList;
